/**
 * "The client cannot see this matter", said on the matter itself.
 *
 * Access to a matter is granted per contact, and a matter nobody holds is invisible to the
 * client however much is filed under it. A firm once asked a signed-in client for a
 * document on such a matter; the client's app said "No matters open yet" and nothing on
 * this screen said why. So the notice is persistent rather than a toast somebody might
 * miss, and it leads to the one screen that fixes it.
 *
 * A warning, not a block. Preparing a matter before anybody is invited is ordinary.
 */

import { Link } from 'react-router-dom';

export function ClientVisibilityNotice({
  clientId,
  matterLabel,
}: {
  clientId: string;
  matterLabel: string;
}) {
  const noun = matterLabel.toLowerCase();
  return (
    <div
      role="status"
      className="mb-4 rounded border border-warning/30 bg-warning-subtle px-3 py-2"
    >
      <p className="text-sm font-medium text-ink">
        The client cannot see this {noun} in their portal yet
      </p>
      <p className="text-sm text-ink-muted">
        Documents you ask for and updates you publish on it will not appear in their app.
        Invite the client&rsquo;s primary contact, or give a contact this {noun}, on the{' '}
        <Link to={`/clients/${clientId}?tab=portal`} className="text-primary hover:underline">
          Portal access tab
        </Link>
        .
      </p>
    </div>
  );
}
